import axios from 'axios';

class StatusService{
    static async getWeather() {
      try {
        const response = await axios.get("/weather");
        return response.data;
      } catch (error) {
        console.error("Error fetching weather data:", error);
        throw new Error("Could not fetch weather data");
      }
    };
}

export default StatusService;